import { useTracking } from 'react-tracking';
import ReportSubSection from '@components/ReportSubSection';
import ReportNextSteps from '@components/ReportNextSteps';
import useDividendInvestingIdea from '@/pages/CompanyReport/hooks/useDividendInvestingIdea';
import loadable from '@loadable/component';
import { useVisibleSectionsIsPristine } from '../../../VisibleSectionsContextProvider';
import { useDividendTranslation } from '../../hooks/useDividendTranslations';
import type { ISO2 } from '@/constants/countries';

const NextSteps = loadable(
  () => import('@/pages/CompanyReport/components/Overview/components/NextSteps')
);

export interface DividendNextStepsProps {
  countryISO: '' | ISO2;
  industryPrimaryName: string;
}

export const DividendNextSteps = ({
  countryISO,
  industryPrimaryName,
}: DividendNextStepsProps) => {
  const payload = useDividendInvestingIdea(countryISO.toLowerCase());
  const isPristine = useVisibleSectionsIsPristine();
  const { Track } = useTracking({
    type: 'track',
    subject: 'DividendNextSteps',
  });
  const t = useDividendTranslation();
  return (
    <Track>
      <ReportSubSection
        titleElement={isPristine ? 'h2' : 'h3'}
        title={t('subSection.6.heading')}
        body={
          <ReportNextSteps>
            <li>
              {typeof payload !== 'undefined' && (
                <NextSteps
                  link={payload.linkToInvestingIdea}
                  industry={industryPrimaryName}
                  section="dividend"
                  market={countryISO}
                />
              )}
            </li>
          </ReportNextSteps>
        }
      />
    </Track>
  );
};
